import { useContext } from "react";
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from "@material-ui/core";
import { ticketsDashboardContext } from "./TIcketsDashboardContext";
import ClickableAssignee from "./components/ClickableAssignee";
import { ticketsContext } from "views/Tickets/TicketsContext";
import { applicationContext } from "helpers/services";


let TicketsDashboard = () => {
    let { usersDashboard } = useContext(ticketsDashboardContext)
    let { supplier } = useContext(ticketsContext)
    let { assignableUsers } = useContext(applicationContext)

    return (
        <>
            <Typography variant="h4">Ticket by assignee</Typography>

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>User</TableCell>
                        <TableCell align="right">C.S. Assignee</TableCell>
                        <TableCell align="right">Assignee</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {usersDashboard.map((x, i) =>
                        <TableRow key={i} hover>
                            <TableCell component="th" scope="row">
                                {assignableUsers.getValueByKey(x.email, 'email', 'name')}</TableCell>
                            <TableCell align="right">
                                <ClickableAssignee value={x.csAssignee} csAssignee={x.email} supplier={supplier} />
                            </TableCell>
                            <TableCell align="right">
                                <ClickableAssignee value={x.assignee} assignee={x.email} supplier={supplier} />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {usersDashboard.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={3}><i>No tickets were found</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </>
    )
}

export default TicketsDashboard;